import React from 'react';

const ProgressBar = (props) => {
  const { completed } = props;

  const containerStyles = {
    height: 5,
    //width: '100%',
    backgroundColor: '#e0e0de',
    borderRadius: 5,
    //   marginTop: 10
  };

  const fillerStyles = {
    height: '110%',
    width: `${completed}%`,
    backgroundColor: 'rgb(124, 191, 66)',
    borderRadius: 'inherit',
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
      </div>
    </div>
  );
};

export default ProgressBar;
